import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import DriverAWBTableMobile from './DriverAWBTableMobile';
import DriverETASelect from './DriverETASelect';
import menuIcon from '../../../assets/icon_fd_u91.png';

import { OfflineRfsOrder } from '../../../models/OfflineRfs';

import { Moment as MomentType } from 'moment';

import style from './driverETA.module.css';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      width: '96%',
      height: '48px',
      margin: '25px 0 0 2%',
      textTransform: 'none'
    },

    tabsRoot: {
      width: '100%',
      background: 'var(--primaryblue)',
      marginTop: '10px'
    },
    tabsIndicator: {
      backgroundColor: '#1890ff00',
    },
    tabRoot: {
      borderBottom: '1px solid #e8e8e8',
      background: 'var(--primaryblue)',
      color: '#FFF',
      boxSizing: 'border-box',
      border: '1px solid #FFF',
      '&$tabSelected': {
      }
    },
  });

interface DropOffOrderDriverProps {
  classes: any;
  dropOffOrder: OfflineRfsOrder;
  dropOffTimeError: boolean;
  pickupDate: MomentType | string;
  selectETA: () => void;
  tabValue: number;
  handleChange: (event: any, value:number) => void;
  destination: { lat: number, lng: number } | null;
  userLocation: { lat: number, lng: number } | null;
  handleUpdate: (type: string) => void;
  eta: string;
  arrivalTime: Date;
  setETAAuto: boolean;
  changeEta: (event: any) => void;
};

const driverETADriver = (props: DropOffOrderDriverProps) => {

  const { classes, dropOffOrder, tabValue } = props;
  
  return (
    <div className={ style.container }>

      <div className={ style.header }>
        <img alt="logo" src={ menuIcon } className={ style.img } />

        <div className={ style.orderNumber }>
          <div>
            <span>{ dropOffOrder.rfs_number }</span>
            <span className={ style.locationName }>{ dropOffOrder.org }-{ dropOffOrder.dst }</span>
          </div>

          <div className={ style.arrivalDock }>
            <span>Arrives at:</span> { dropOffOrder.dock_name ? dropOffOrder.dock_name : 'Dock is not defined yet' }
          </div>
        </div>
      </div>

      <div className={ style.flex }>
        <Tabs
          value={tabValue}
          variant="fullWidth"
          onChange={props.handleChange}
          classes={ { root: classes.tabsRoot, indicator: classes.tabsIndicator } }
        >
          <Tab classes={ { root: classes.tabRoot, selected: classes.tabSelected } } label="Manifest" />
          <Tab classes={ { root: classes.tabRoot, selected: classes.tabSelected } } label="Ops Info" />
        </Tabs>
      </div>
      { tabValue === 0 && dropOffOrder.list && <DriverAWBTableMobile orderListItems={ dropOffOrder.list } /> }
      { tabValue === 1 && <DriverETASelect order={ dropOffOrder } destination={ props.destination } userLocation={ props.userLocation } eta={ props.eta } handleUpdate={ props.handleUpdate } arrivalTime={ props.arrivalTime } changeEta={ props.changeEta } /> }
    </div>
  );
}

export default withStyles(styles)(driverETADriver);